import React, { useEffect, useState } from "react";
import { Section } from "@origin-digital/ods-core";
import { useAppContext } from "../../AppContext";
/* eslint-disable-next-line import/extensions */
import content from "../../cms/trending.json";
import { fetchTrendingQuestions } from "../../services/faq";
import { findArticleLabel } from "../../services/label";
import { Trending, NumberOfItems } from "./Trending";
import { ITrendingItem } from "./TrendingItem";

interface ITrendingControllerProps {
  labelId?: string;
  numOfItems?: number;
}

export const TrendingController = ({
  labelId,
  numOfItems,
}: ITrendingControllerProps) => {
  const {
    customerContext,
    navigation,
    articleLabels,
    config,
  } = useAppContext();
  const [loading, setLoading] = useState<boolean>(true);
  const [items, setItems] = useState<ITrendingItem[]>([]);
  const title =
    customerContext && customerContext === "auth"
      ? content.auth
      : content.unauth;
  const { ttl } = config;

  useEffect(() => {
    if (!customerContext) return;
    fetchTrendingQuestions(
      {
        context: customerContext,
        labelId,
        items: numOfItems,
      },
      { ttl }
    ).then((faq) => {
      setLoading(false);
      const truncateditems = faq?.slice(0, NumberOfItems.Triple);
      if (truncateditems) {
        truncateditems.map((item) => {
          const { category, subcategory } = findArticleLabel(
            item.articleId,
            articleLabels,
            navigation
          );
          item["category"] = category;
          item["subcategory"] = subcategory;
          return item;
        });
        setItems(truncateditems);
      }
    });
  }, [labelId, articleLabels, navigation]);

  return !loading && items.length > 0 ? (
    <Section>
      <Trending title={title} items={items} />
    </Section>
  ) : null;
};
